import HOPRichTextEditor from '@/shared/components/HOPComponents/HOPRichTextEditor/HOPRichTextEditor'
import OptInSmsTextField from '@/shared/components/HOPComponents/OptInSmsTextField/OptInSmsTextField'
import { FormControl } from 'baseui/form-control'
import { Input } from 'baseui/input'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import useModalResources from './useModalResources'

const ModalResources = ({
  isOpen,
  close,
  selectedProductType,
  resources,
  updateResources,
  saveResources,
  isSavingResources,
  isOptInSmsHidden,
}) => {
  const { t, saleScript, learningLink, emailTemplateLink, objections, optInSmsText, onOptInSmsTextChange } =
    useModalResources(resources, updateResources)

  return (
    <Modal
      onClose={close}
      isOpen={isOpen}
      overrides={{
        Dialog: {
          style: {
            width: '80vw',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <ModalHeader>
        {t('additionalProductsManagement:resources.modal_title')} {selectedProductType[0]?.label}
      </ModalHeader>
      <ModalBody>
        <FormControl label={t('additionalProductsManagement:resources.learning_link')}>
          <Input
            id='learning-link-input'
            value={learningLink}
            onChange={e => updateResources('learning_link', e.target.value)}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.email_template_link')}>
          <Input
            id='email-template-link-input'
            value={emailTemplateLink}
            onChange={e => updateResources('email_template_link', e.target.value)}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.sale_script')}>
          <HOPRichTextEditor
            id='sale-script-editor'
            initialValue={saleScript}
            onChange={html => updateResources('sale_script', html)}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.objections')}>
          <HOPRichTextEditor
            id='objections-editor'
            initialValue={objections}
            onChange={html => updateResources('objections', html)}
          />
        </FormControl>
        <OptInSmsTextField hidden={isOptInSmsHidden} value={optInSmsText} onChange={onOptInSmsTextChange} />
      </ModalBody>
      <ModalFooter>
        <ModalButton kind='tertiary' onClick={close}>
          {t('additionalProductsManagement:resources.cancel')}
        </ModalButton>
        <ModalButton onClick={saveResources} isLoading={isSavingResources} kind='primary'>
          {t('additionalProductsManagement:resources.save')}
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default ModalResources
